<div
  class="grid grid-cols-1 xl:grid-cols-[1fr_1.3fr] h-screen overflow-hidden bg-white font-[Montserrat] max-w-[1280px] mx-auto"
>
  <!-- LEFT PANE -->
  <div
    class="flex flex-col justify-center items-center gap-6 px-6 sm:px-10 lg:px-16 text-center h-full"
  >
    <p-image
      class="w-24 h-auto mb-2"
      src="assets/images/logo.png"
      alt="NITI"
    ></p-image>

    <div>
      <h2 class="font-bold text-2xl text-[var(--color-text-primary)] mb-2">
        Welcome!
      </h2>
      <p class="text-sm text-[#6b7280]">
        Please log in to your account to continue.
      </p>
    </div>

    <form
      class="flex flex-col gap-3 mt-2 w-full max-w-[453px]"
      [formGroup]="loginForm"
      (ngSubmit)="onSubmit()"
    >
      <label
        class="block text-xs text-[var(--color-text-primary)] font-bold text-left"
        for="email"
      >
        Email Address
      </label>
      <input
        pInputText
        id="email"
        type="email"
        formControlName="email"
        class="w-full h-12 rounded-lg border border-gray-200 pl-4 pr-3 py-4 text-sm text-[var(--color-text-primary)] outline-none focus:border-[var(--color-primary-500)] focus:ring-2 focus:ring-[rgba(239,71,111,0.15)]"
        placeholder="Enter your registered email address"
      />
      @if (loginForm.get('email')?.invalid && loginForm.get('email')?.touched) {
      <div class="text-red-500 text-xs mt-1 text-left">
        @if (loginForm.get('email')?.errors?.['required']) { Email is required }
        @else if (loginForm.get('email')?.errors?.['email']) { Please enter a
        valid email address }
      </div>
      }

      <!-- Password input -->
      <label
        class="block text-xs text-[var(--color-text-primary)] mt-2 font-bold text-left"
        for="password"
      >
        Enter password
      </label>
      <div class="relative w-full">
        <p-password
          inputId="password"
          formControlName="password"
          [feedback]="false"
          [toggleMask]="true"
          [placeholder]="'Enter your password'"
          [inputStyleClass]="
            'custom-password-input w-full h-12 rounded-lg border border-gray-200 pl-4 pr-9 py-4 text-sm text-[var(--color-text-primary)] outline-none focus:border-[var(--color-primary-500)] focus:ring-2 focus:ring-[rgba(239,71,111,0.15)]'
          "
        ></p-password>
        @if (password?.errors?.['required'] && password?.touched) {
        <div class="text-red-500 text-xs mt-1 text-left">
          Password is required
        </div>
        }
        @if (errorMessage) {
        <div class="text-red-500 text-sm mt-2 text-left">
          {{ errorMessage }}
        </div>
        }
      </div>

      <!-- Remember + Forgot password -->
      <div class="flex justify-between items-center text-xs mt-1">
        <div class="flex items-center">
          <p-checkbox
            formControlName="remember"
            [binary]="true"
            inputId="remember"
          ></p-checkbox>
          <label class="ml-2" for="remember">Remember me</label>
        </div>
        <a
          class="text-xs text-black hover:underline"
          routerLink="/forgot-password"
          >Forgot Password?</a
        >
      </div>

      <!-- Button -->
      <button
        pButton
        type="submit"
        label="Login"
        icon="pi pi-angle-right"
        iconPos="right"
        [disabled]="loginForm.invalid || isLoading"
        class="w-full h-12 rounded-lg pt-[14px] pb-4 px-4 border-l-[3px] border-l-black/15 !bg-[var(--color-table-header)] hover:!bg-[var(--color-primary-red)] !text-white !border-none cursor-pointer mt-3 disabled:opacity-50 disabled:cursor-not-allowed"
      ></button>
    </form>
  </div>

  <!-- RIGHT PANE -->
  <div
    class="hidden xl:flex h-full items-center justify-center bg-[url('assets/images/signin-bg.png')] bg-no-repeat bg-cover bg-center rounded-[30px] p-6 overflow-hidden"
  >
    <div class="w-full max-w-[820px] text-center px-10">
      <p-image
        class="w-full mb-6"
        src="assets/images/signin-image.png"
        alt="Application preview"
      ></p-image>
      <h3
        class="font-bold text-[34.16px] leading-[1] text-center mb-3 max-w-[820px] mx-auto"
      >
        Securely manage and access all your documents
      </h3>
      <p class="text-sm text-[#4b5563] mx-auto max-w-[820px]">
        Centralize your documents for improved organization, enhanced security,
        and seamless collaboration across teams.
      </p>
    </div>
  </div>
</div>

<!-- Fullscreen Loading Overlay -->
@if (isLoading) {
<app-loader type="fullscreen" message="Signing you in..." size="large">
</app-loader>
}
